import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BookingsViewService {

  private cabRankMap$ = new Subject();
  public cabRankMap = this.cabRankMap$.asObservable();
  private previousCabRankMap = {};
  public cityName = new BehaviorSubject<string>('');
  public bookingType = new BehaviorSubject<string>('');
  public clearUpdate = new BehaviorSubject<boolean>(false);
  constructor(public apiService: ApiService, private authService: AuthService,  private http: HttpClient, ) {
  }



  setCabRank(val) {
    const value = val ? { ...this.previousCabRankMap, ...val} : null;
    this.cabRankMap$.next(value);
    this.previousCabRankMap = value;
  }

  removecabRank(bookingId) {
    if (this.previousCabRankMap) {
      delete this.previousCabRankMap[bookingId];
    }
  }

  fetchAvailablecabs(bookingId) {
    return this.apiService.httpRequest({
      url: 'cabAvailability',
      type: 'GET',
      queryParams: {
        bookingId
      }
    });
  }

  fetchVendorConfig(){
    let city, bookingType;
    this.cityName.subscribe(res => city = res);
    this.bookingType.subscribe(res => bookingType = res);
    return this.apiService.httpRequest({
      url: 'vendorAllocation',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        city,
        bookingType
      }
    });
  }

 saveVendorConfig(body, city, bookingType){
  const url = `${environment.apiBaseUrl}spot/vendorAllocationPercentages/${this.authService.user.buId}/${city}/${bookingType}`;
  return this.http.post(url, body, {responseType: 'text'});
 }

  fetchConfigApprover(approvalRolesForAVA){
    const queryParams = {
      buid: this.authService.user.buId,
      roles: approvalRolesForAVA
    };
    return this.apiService.httpRequest({
      url: 'fetchAllEmployeesByRole',
      type: 'GET',
      queryParams
    });
  }

  fetchVehicleConfig(city){
    return this.apiService.httpRequest({
      url: 'vehicleAllocation',
      type: 'GET',
      queryParams: {
        city,
        buid: this.authService.user.buId,
        empGuId: this.authService.user.employeeGuid,
      }
    });
  }

  saveDbvaConfig(body, city){
    const url = `${environment.apiBaseUrl}spot/vehicleDesignationConfig/${this.authService.user.buId}/${city}?requesterGuId=${this.authService.empGuid}`;
    return this.http.post(url, body, {responseType: 'text'});
  }

  updateHighCapVehicle(body: any){
    return this.apiService.httpRequestAsText({
      url: 'updateHighCapVehicle',
      type: 'POST',
      body: body,
      queryParams: {
        empGuId: this.authService.user.employeeGuid,
        buid: this.authService.user.buId, 
      }
    });
  }

   fetchMarshals(bookingID){
    const queryParams = {
      buid: this.authService.user.buId,
      bookingID
    };
    return this.apiService.httpRequest({
      url: 'fetchMarshals',
      type: 'GET',
      queryParams
    });
   }

   fetchMarshalOffice(){
    const queryParams = {
      buid: this.authService.user.buId,
    };
    return this.apiService.httpRequest({
      url: 'fetchMarshalOffice',
      type: 'GET',
      queryParams
    });
   }

   postMarshal(body, bookingID){
    const url = `${environment.apiBaseUrl}spot/getPlannedMarshal/${this.authService.user.buId}/${bookingID}`;
    return this.http.post(url, body, {responseType: 'text'});
   }
   deleteMarshal(bookingID){
    const url = `${environment.apiBaseUrl}spot/removeMarshal/${bookingID}`;
    return this.http.get(url, {responseType: 'text'});
   }
}
